import { Box, SegmentedControl, SegmentedControlOption, Text } from '@bechtel/gds';
import { OwnershipLevel } from '@bechtel/types';
import { Trans } from '@lingui/macro';
import { FC } from 'react';

export interface OwnerShipProps {
  selectedOwnershipLevel: OwnershipLevel;
  setSelectedOwnershipLevel: (ownershipLevel: OwnershipLevel) => void
}

export const Ownership: FC<OwnerShipProps> = ({selectedOwnershipLevel, setSelectedOwnershipLevel}) => {

  return (
    <Box alignItems={{ sm: 'center' }}>
      <Text size="300" color="grey.1000" weight="600">
        <Trans>Ownership Level:</Trans>
      </Text>
      &nbsp;&nbsp;
      {/* TODO: One-off segmented control style with height of button not matching GDS. Hence styled inline. Move
        button style to GDS if this height is used in other places  */}
      <SegmentedControl style={{ width: '248px' }}>
        <SegmentedControlOption
          olOption
          selected={selectedOwnershipLevel === OwnershipLevel.PRIMARY}
          onClick={() => setSelectedOwnershipLevel(OwnershipLevel.PRIMARY)}
          style={{ height: '22px' }}
        >
          <Trans>Primary</Trans>
        </SegmentedControlOption>
        <SegmentedControlOption
          selected={selectedOwnershipLevel === OwnershipLevel.SECONDARY}
          onClick={() => setSelectedOwnershipLevel(OwnershipLevel.SECONDARY)}
          style={{ height: '22px' }}
        >
          <Trans>Secondary</Trans>
        </SegmentedControlOption>
      </SegmentedControl>
    </Box>
  );
};
